import { Route, Routes, Navigate , useLocation} from 'react-router-dom';
import './App.css';
import Navbar from './Components/Navbar';
import Home from './Views/Home';
import React, {useState} from 'react';
import Footer from './Components/Footer';
import SocialTree from './Views/Reviews';
// import SocialTree from './Views/Reviews';

function App() {

	const [activeTab, setActiveTab] = useState("Home");

	const handleTabClick = (tabName) => {
		setActiveTab(tabName);
	};

	const location = useLocation();

	const isActive = (tabName) => {
		return activeTab === tabName ? " border-t-main-color border-t-2 p-2" : "";
	};

	return (
		<main>
			{location.pathname !== '/Reviews'? (
        		<Navbar handleTabClick = {handleTabClick} isActive = {isActive}  />
     		):null}
			<Routes>
				<Route path='/' element = {<Home />} />
				<Route path='/Reviews' element = {<SocialTree />} />
				<Route path="*" element={<Navigate to="/" />} />
			</Routes>
			{location.pathname !== '/Reviews'? (
				<Footer />
			):null}
		</main>
	);
}

export default App;